import { render } from "./fees-subpage.vue?vue&type=template&id=676f823e&scoped=true"
import script from "./fees-subpage.vue?vue&type=script&lang=js"
export * from "./fees-subpage.vue?vue&type=script&lang=js"

import "./fees-subpage.vue?vue&type=style&index=0&id=676f823e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676f823e"]])

export default __exports__